




















































import Utils from "@/utils/utils";
import Vue from "vue";

export default Vue.extend({
  name: "TableComplement",
  props: {
    intervalFunction: {
      type: Function,
      default: () => undefined
    },
    upload_multiple: {
      type: Boolean,
      default: false
    },
    displayDownload: {
      type: Boolean,
      default: false
    },
    changeDataDisplay: {
      type: Boolean,
      default: false
    }
  },
  data: (): any => {
    return {
      interval: null,
      intervalColor: "white"
    };
  },
  methods: {
    DisplayCreate(): void {
      this.$emit("create");
    },
    DownloadTableData(): void {
      this.$emit("downloadTableData");
    },
    DisplayFilter(): void {
      this.$emit("filter");
    },
    DisplayMultipleAdd(): void {
      this.$emit("mutilpleAdd");
    },
    ChangeDisplayedData(): void {
      this.$emit("changeData");
    },
    shouldUpdateList(): void {
      if (this.interval === null) {
        this.intervalColor = "orange";
        this.interval = setInterval(this.intervalFunction, 30000);
      } else {
        clearInterval(this.interval);
        this.interval = null;
        this.intervalColor = "white";
      }
    }
  },
  computed: {
    isAdmin(): boolean {
      return Utils.isLoggedUserAdmin();
    }
  },
  beforeDestroy(): void {
    clearInterval(this.interval);
  }
});
